import { useSetState } from '@domain-group/react-hooks'

type UseCarouselParams = {
  initialIndex?: number,
  items: any[],
}

function useCarousel(params: UseCarouselParams) {
  const { initialIndex = undefined, items } = params

  const [state, setState] = useSetState({ selectedIndex: initialIndex })
  const { selectedIndex } = state

  return {
    callbacks: {
      // @ts-expect-error TS18048
      selectNext: () => setState({ selectedIndex: selectedIndex + 1 }),
      // @ts-expect-error TS18048
      selectPrevious: () => setState({ selectedIndex: selectedIndex - 1 }),
      setSelectedIndex: (index?: number) => setState({ selectedIndex: index }),
    },
    canSelectPrevious: selectedIndex !== 0,
    canSelectNext: selectedIndex !== (items.length - 1),
    hasSelectedIndex: selectedIndex !== undefined,
    selectedIndex,
  }
}

export type UseCarouselPayload = ReturnType<typeof useCarousel>

export default useCarousel
